import React, { useState } from 'react';
import { SearchBar } from 'components';
import { useEvents } from 'hooks';

const SearchFilter = () => {
  const { fetchEvents, setFilter, filters } = useEvents();
  const [searchText, setSearchText] = useState(
    filters !== undefined && filters.search !== undefined ? filters.search : ''
  );

  const hitEnter = () => {
    setFilter({ search: searchText });
    const allFilters = Object.assign({}, filters, { search: searchText });
    fetchEvents(allFilters);
  };
  return <SearchBar selector={searchText} setSearchText={setSearchText} hitEnter={hitEnter} />;
};

export default SearchFilter;
